function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/**
 * Draw full MC outline from path start (bottom of left “m”) to the end.
 * Starts at opacity 0 and fades in with the stroke.
 * @param {ParentNode} root
 * @param {{ duration?: number, delay?: number }} [options]
 */
export function playSygnetStroke(root, options = {}) {
  const { duration = 4.5, delay = 0.3 } = options;
  const gsap = window.gsap;
  const path = root.querySelector(".brand-sygnet__path");
  if (!path) return;

  const play = () => {
    const svg = path.ownerSVGElement;
    if (!svg) return;

    svg.setAttribute("overflow", "visible");
    svg.style.overflow = "visible";

    path.removeAttribute("clip-path");
    path.removeAttribute("pathLength");
    path.style.strokeDasharray = "";
    path.style.strokeDashoffset = "";
    path.setAttribute("fill", "none");

    // Path `d` starts at M0,56.98 — bottom of the left m stem
    const length = path.getTotalLength();
    const ctm = path.getScreenCTM();
    const scale = ctm ? Math.hypot(ctm.a, ctm.b) : 1;
    // 1px screen stroke in user units
    const strokeUser = 1 / (scale || 1);

    path.setAttribute("stroke-width", String(strokeUser));
    path.removeAttribute("vector-effect");

    const showFull = () => {
      // Drop dash pattern entirely so the closed path has no end-gap
      path.removeAttribute("stroke-dasharray");
      path.removeAttribute("stroke-dashoffset");
      path.style.strokeDasharray = "none";
      path.style.strokeDashoffset = "0";
    };

    if (!gsap || prefersReducedMotion()) {
      root.style.opacity = "1";
      showFull();
      return;
    }

    gsap.killTweensOf(path);
    gsap.killTweensOf(root);
    gsap.set(root, { opacity: 0 });
    gsap.set(path, {
      attr: {
        "stroke-dasharray": length,
        "stroke-dashoffset": length,
      },
    });

    gsap.to(root, {
      opacity: 1,
      duration: duration * 0.55,
      delay,
      ease: "power2.out",
    });

    gsap.to(path, {
      attr: { "stroke-dashoffset": 0 },
      duration,
      delay,
      ease: "power2.out",
      onComplete: showFull,
    });
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(play);
  });
}

export function initHeroCaptionSygnet() {
  document.querySelectorAll(".hero-caption-img__sygnet").forEach((el) => {
    playSygnetStroke(el, { duration: 4.5, delay: 0.3 });
  });
}
